export enum CurrentLocationUpdatedStatus {
  idle = "idle",
  pending = "pending",
  success = "success",
  fail = "fail",
}
